'use strict';

export default FormData;
